'use strict';

//import data from '../stores/motherdata.json';
//var data = require('../motherdata.json');

import React from 'react';
//import ReactDOM from 'react-dom';
//import Promise from 'promise';
//import axios from 'axios';



require('styles//Mother.css');



class MotherComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state ={items:[]};
  }
  componentDidMount() {
   /* axios.get("motherdata.json")
      .then(res => {
        const items = res.data.data.children.map(obj => obj.data);
        this.setState({ items });
   });*/
    var self=this;
    this.loadJSON(function(response) {
        //console.log(response);
        self.setState({items: JSON.parse(response)});
    });
  }
  createRows(rows){
    return rows.map(this.createRows);
  }
  createRows(row){
    return <tr><td>{row.dateTitle}</td><td><a href={row.url}>{row.title}</a></td></tr>;
  }
  loadJSON(callback){
    var xobj = new XMLHttpRequest();
        xobj.overrideMimeType('application/json');
    xobj.open('GET', 'mother/motherdata.json', true); // Replace 'my_data' with the path to your file
    xobj.onreadystatechange = function () {
          if (xobj.readyState == 4 && xobj.status == '200') {
            // Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
            callback(xobj.responseText);
          }
    };
    xobj.send(null);
  }
  render() {
   // var data = require('../stores/motherdata.json');
   // console.log(data.length);
    return (
      <div className="mother-component">
        <h3 className="h3">Оперативные данные по материнской и детской смертности</h3>
        <table className="datatable">
          <tbody>
          {this.state.items.map((row, index) =><tr key={index+1}><td>{row.dateTitle}</td><td><a href={row.url}>{row.title}</a></td></tr>)}
          </tbody>
        </table>
      </div>
    );
  }
}

MotherComponent.displayName = 'MotherComponent';

// Uncomment properties you need
// MotherComponent.propTypes = {};
// MotherComponent.defaultProps = {};

export default MotherComponent;



// WEBPACK FOOTER //
// ./src/components/MotherComponent.js